import { Spin } from "antd";
import React, { useState } from "react";
import ImageUploader from "react-images-upload";
import { useTranslation } from "react-i18next";


const UploadImage = (props) => {
    const { t } = useTranslation("dashboard");
    const [loading, setLoading] = useState(false);

    const onDrop = (pictureFiles, pictureDataURLs) => {
        // const newImagesUploaded = pictureDataURLs.slice(
        //     props.defaultImages.length
        // );
        setLoading(true);
        setTimeout(() => {
            const newImagesUploaded = pictureDataURLs.slice((props.defaultImages || []).length);
            props.handleChange(newImagesUploaded);
            setLoading(false);
        }, 1000);
        // const newImagesUploaded = pictureDataURLs.slice((props.defaultImages || []).length);
        // props.handleChange(newImagesUploaded);                       
    };

    return (
        <div style={{ position: "relative" }}>

            {/*<Spin spinning={loading}>*/}

            <ImageUploader
                withIcon={false}
                withLabel={false}
                //  withPreview={true}
                buttonText={t("UploadMedia")}
                // fileSizeError={"File size is too big!"}
                fileTypeError={"This extension is not supported!"}
                onChange={onDrop}
                imgExtension={props.imgExtension}
                maxFileSize={props.maxFileSize}
                singleImage={true}
            // defaultImages={props.defaultImages}
            />
            {/*</Spin>*/}
        </div>
    );

}

export default UploadImage;